import { useCallback } from 'react';
import { useLazyFetchPdfReportQuery } from '../service';
//@ts-ignore
import { saveAs } from 'file-saver';
import { base64ToArrayBuffer } from '../../shared/utils';

export default function useDownloadPdf() {
    const [fetchPdfReport, { isLoading: isLoadingPdfReport }] = useLazyFetchPdfReportQuery();

    const downloadPdf = useCallback(
        async (reportUrl: string, reportGuid: string, templateGuid: string) => {
            try {
                const pdfData = await fetchPdfReport({ report_guid: reportGuid, report_url: reportUrl, template_guid: templateGuid }).unwrap();

                const pdfBlob = new Blob([base64ToArrayBuffer(pdfData.pdf_content)], { type: 'application/pdf' });

                saveAs(pdfBlob, pdfData.file_name);
            } catch (error) {}
        },
        [fetchPdfReport]
    );

    return {
        downloadPdf,
        isLoadingPdfReport,
    };
}
